import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { WEEK_DAYS } from 'settings/constants/day'

export const useProximityMapFormState = () => {
  const { watch, control } = useFormContext()
  const radiusCommitted = watch('radiusCommitted')
  const startDate = watch('startDate')
  const endDate = watch('endDate')

  const watchedDays = watch(WEEK_DAYS.map(day => `selectedDays.${day}`))
  const selectedDaysMap = useMemo(() => {
    const days = {}
    WEEK_DAYS.forEach((day, index) => {
      days[day] = watchedDays?.[index] ?? true
    })
    return days
  }, [watchedDays])

  // useWatch subscribes to the entire selectedRoutes subtree so any nested
  // setValue('selectedRoutes.{id}', ...) call triggers a re-render here.
  const selectedRoutes = useWatch({ control, name: 'selectedRoutes' })
  const selectedRoutesMap = useMemo(() => selectedRoutes ?? {}, [selectedRoutes])

  return { radiusCommitted, selectedDaysMap, selectedRoutesMap, startDate, endDate }
}
